export class DashboardEvents {
    public static AddWidgetButtonClicked: string = "dashboards.dashboard.addwidget";
    public static AddDashboardButtonClicked: string = "dashboards.dashboard.dashboard.new";
    public static ToggleEditMode: string = "dashboards.dashboard.toggle-edit";
    public static ManageDashboardsButtonClicked: string = "dashboards.dashboard.managedashboards";

    public static DashboardUpdated: string = "dashboards.dashboard.dashboardupdated";
    public static RequestEditModeToggle: string = "dashboards.dashboard.editmodetogglerequested";
    public static HeaderUpdate: string = "dashboards.dashboard.headerupdate";
    public static BladeToggled: string = "dashboards.dashboard.bladetoggled";

    /**
     * Modern web platform code needs to know when the view has finished initializing (loading modules, setting up event listeners,
     * rendering JQuery elements...) so it can know when to unhide the edit view and stop showing a loading spinner.
     */
    public static ViewInitialized: string = "dashboards.dashboard.viewinitialized";

    /**
     * Modern web platform code needs to be notified about all changes to the dashboard in edit mode
     * (moving/adding/removing/reconfiguring widgets). The 'DashboardUpdated' event is inadequate for this
     * because it does not fire for several of these cases. V2 covers more modifications.
     */
    public static DashboardUpdatedV2: string = "dashboards.dashboard.DashboardUpdatedV2";
}